module.exports = __webpack_public_path__ + "img/color-d-2.02c01a6.webp";